import { render, staticRenderFns } from "./AdminEnableTfa.vue?vue&type=template&id=14dc2f4c"
import script from "./AdminEnableTfa.vue?vue&type=script&lang=js"
export * from "./AdminEnableTfa.vue?vue&type=script&lang=js"
import style0 from "./AdminEnableTfa.vue?vue&type=style&index=0&id=14dc2f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports